export default __webpack_public_path__ + "static/media/notification.e6c9fabc.svg";